import axios from "axios"
//ELMENT需单独引入后使用
import {
	ElMessage
} from 'element-plus'
const baseURL = 'https://open.jfcorp.cn/express';

// //加载动画、屏蔽罩
// import Spin from './Spin/index.ts';
// //ant-design组件用于展示提醒信息
// import { message} from 'ant-design-vue';

//数据类型
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8"
axios.defaults.withCredentials = true; // 
// 创建axios实例
const request = axios.create({
	// 基础请求地址，可根据环境配置
	baseURL: baseURL,
	// 请求超时时间
	timeout: 1000000,//10000
	// 跨域请求时是否携带凭证（如 cookie）
	withCredentials: true,
	// 请求头默认配置
	headers: {
		'Content-Type': 'application/json;charset=utf-8'
	}
})
// 请求拦截器
request.interceptors.request.use(
	(config) => {
		// 在这里可以对所有请求进行预处理，请求头中添加token
		const Authorization = localStorage.getItem('Authorization');
		if (Authorization) {
			config.headers['Authorization'] = Authorization;
		}

		//打开加载动画
		// const spinIntance = Spin.service();
		// 如果一切正常，则必须返回config对象或者Promise.resolve(config)
		return config
	},
	(error) => {
		ElMessage.error('请求配置错误：' + error);
		// 对请求错误做些什么
		// 返回Promise.reject(error)，这样会触发后续的错误处理器
		Promise.reject(error)
	}
)

// 响应拦截器
request.interceptors.response.use(
	(res) => {
		//关闭加载动画
		// Spin.service().close();
		let data = res.data
		if (data.code != 0) {
			if (data.code > 2200 && data.code < 2212) {
				//错误提示
				ElMessage.error('登录状态失效，请重新登录');
				setTimeout(() => {
					window.location.replace("/login");
				}, 400) //跳转
			} else {
				if (String(data.msg).length < 22) {
					//错误提示
					ElMessage.error(data.msg);
				} else {
					//错误提示
					ElMessage.error('服务响应后台异常');

				}
			}
		}
		return data // （相当于返回的 res 被自动 剥掉一层，变成 data 字段）
	},
	(error) => {
		//关闭加载动画
		// Spin.service().close();
		//错误提示
		ElMessage.error('服务响应失败');
		if (error?.request?.status === 401 && location.pathname !== "/login") {
			// 当用户登录超时时，清空登录状态
			// const store = useUsersStore()
			// store.user = {}
			// 跳转到登录页
			if (error.config.url !== "/api/user/info") {
				sessionStorage.setItem("LOGIN_REDIRECT", location.hash.substr(1))
				// router.replace("/login")
			}
		}
		return Promise.reject(error)
	},
)
// 封装通用请求方法
const apiService = {
  // GET 请求
  // get(url, params = {}, config = {}) {
  //   return service.get(url, { params, ...config });
  // },
  
  // POST 请求
  post(data = {}, config = {}) {
    return request.post(baseURL, data, config);
  },
  
  // // PUT 请求
  // put(url, data = {}, config = {}) {
  //   return service.put(url, data, config);
  // },
  
  // // DELETE 请求
  // delete(url, params = {}, config = {}) {
  //   return service.delete(url, { params, ...config });
  // },
  
  // // 上传文件（FormData）
  // upload(url, fileData, config = {}) {
  //   return service.post(url, fileData, {
  //     headers: { 'Content-Type': 'multipart/form-data' },
  //     ...config
  //   });
  // }
};

export default apiService